import { Theme, webLightTheme } from "@fluentui/react-components";

// Zegal brand palette (sourced from
// zegal-apps/packages/apps/lite/src/common/components/theme.js).
export const zegalColors = {
  brand: "#6B88EF",
  brandLight: "#90A6F3",
  brandDark: "#4469EB",
  surfaceTint: "#EDF0FD",
  surfaceTint2: "#DAE1FB",
  accent: "#FEDB5B",
  textPrimary: "#333333",
  textSecondary: "#403D58",
  border: "rgba(170, 170, 170, 0.6)",
  divider: "rgba(0, 0, 0, 0.15)",
  error: "#EB5757",
  success: "#82C26E",
  warning: "#F8961E",
  info: "#5CBEFF",
} as const;

const fontFamily =
  "'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

// Override only the tokens that affect visible UI rather than hand-rolling
// the full 16-step BrandVariants ramp.
export const zegalTheme: Theme = {
  ...webLightTheme,

  fontFamilyBase: fontFamily,

  colorBrandBackground: zegalColors.brand,
  colorBrandBackgroundHover: zegalColors.brandDark,
  colorBrandBackgroundPressed: zegalColors.brandDark,
  colorBrandBackgroundSelected: zegalColors.brandDark,
  colorCompoundBrandBackground: zegalColors.brand,
  colorCompoundBrandBackgroundHover: zegalColors.brandDark,
  colorCompoundBrandBackgroundPressed: zegalColors.brandDark,

  colorBrandForeground1: zegalColors.brand,
  colorBrandForeground2: zegalColors.brandDark,
  colorBrandForegroundLink: zegalColors.brand,
  colorBrandForegroundLinkHover: zegalColors.brandDark,
  colorBrandForegroundLinkPressed: zegalColors.brandDark,
  colorCompoundBrandForeground1: zegalColors.brand,
  colorCompoundBrandForeground1Hover: zegalColors.brandDark,

  colorBrandStroke1: zegalColors.brand,
  colorBrandStroke2: zegalColors.brandLight,
  colorCompoundBrandStroke: zegalColors.brand,
  colorCompoundBrandStrokeHover: zegalColors.brandDark,

  colorNeutralBackground1Hover: zegalColors.surfaceTint,
  colorNeutralBackground1Selected: zegalColors.surfaceTint,
  colorSubtleBackgroundHover: zegalColors.surfaceTint,
  colorSubtleBackgroundSelected: zegalColors.surfaceTint2,

  borderRadiusSmall: "2px",
  borderRadiusMedium: "3px",
  borderRadiusLarge: "4px",
  borderRadiusXLarge: "6px",
};
